import React, { SVGProps } from "react";

export default function SupFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.93237 2.20832L4.71074 17.9652L5.69555 17.7916L2.91718 2.03467L1.93237 2.20832Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5677 9.77842L18.0676 13.7784L15.158 14.5058C14.4449 14.6841 13.6964 14.6624 12.9948 14.4432L7.13474 12.6119C6.72656 12.4843 6.29837 12.454 5.88316 12.5184C5.84507 12.5243 5.80709 12.531 5.76925 12.5385L4.25623 3.95769L4.84111 3.73836C5.63795 3.43954 6.50933 3.40266 7.32858 3.63307L13.045 5.24082C13.7151 5.42929 14.4228 5.43962 15.0981 5.2708L17.0677 4.77842L14.5677 9.77842ZM16.2373 13.2052L14.9155 13.5357C14.3806 13.6694 13.8193 13.6531 13.2931 13.4887L7.43302 11.6574C7.16048 11.5723 6.88139 11.519 6.60105 11.4971L5.38655 4.6093C5.92975 4.44694 6.50937 4.44146 7.05784 4.59572L12.7743 6.20347C13.5662 6.4262 14.4001 6.4499 15.2021 6.27348L13.3731 9.93167L16.2373 13.2052Z"
        fill="currentColor"
      />
    </svg>
  );
}
